import Compressor from "compressorjs";

export const compressorUtil = (file: File, onSucceed: (binary: string) => void, onError: () => void) => {
  return new Compressor(file, {
    quality: 0.4,
    success(result) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const matches = reader.result!.toString().match(/^data:(?<mimeType>[\w/+]*);base64,(?<binary>.+)$/);
        onSucceed(matches!.groups!.binary);
      };
      reader.readAsDataURL(result);
    },
    error: onError,
  });
};
